import { render, staticRenderFns } from "./WhatsAppChannel.vue?vue&type=template&id=3d29f5a5&scoped=true&"
import script from "./WhatsAppChannel.vue?vue&type=script&lang=js&"
export * from "./WhatsAppChannel.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppChannel.vue?vue&type=style&index=0&id=3d29f5a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d29f5a5",
  null
  
)

export default component.exports